<template>
  <v-bottom-navigation app absolute>
    <footer class="bigd-footer" style="font-family: Arial, serif">
      <div class="bigd-panel bigd-panel-default">
        <div class="bigd-panel-body">
          <div class="bigd-container">
            <div class="bigd-row">
              <div class="bigd-col-md-2">
                <a href="https://ngdc.cncb.ac.cn" target="_blank">
                  <img :src="bigd_site + 'static/image/ngdc-logo-blue.png'" style="margin-top: 15px" />
                </a>
                <h3 class="bigd-text-primary">National Genomics Data Center</h3>
                <ul class="bigd-list-unstyled">
                  <li><i class="icon phone"></i> 86-10-84097298</li>
                  <li><i class="icon mail"></i> ngdc(at)big.ac.cn</li>
                  <li><a :href="bigd_site + 'policies'">Policies and Disclaimers</a></li>
                </ul>
              </div>

              <div class='bigd-col-md-2'>
                <h3>Research & Resources</h3>
                <ul class='bigd-list-unstyled'>
                  <li><a :href="bigd_site + 'databases'">Databases</a></li>
                  <li><a :href="bigd_site + 'tools'">Tools</a></li>
                  <li><a :href="bigd_site + 'standards'">Standards</a></li>
                  <li><a :href="bigd_site + 'research'">Topics & Projects</a></li>
                  <li><a :href="bigd_site + 'publications'">Publications</a></li>
                  <li><a :href="bigd_site + 'annual-report'">Annual Reports</a></li>
                </ul>
              </div>

              <div class='bigd-col-md-2'>
                <h3>Featured</h3>
                <ul class='bigd-list-unstyled'>
                  <li><a href='https://bigd.big.ac.cn/databasecommons' target='_blank'>Database Commons</a></li>
                  <li><a href='https://ngdc.cncb.ac.cn/genbase/' target='_blank'>GenBase</a></li>
                  <li><a href='https://bigd.big.ac.cn/gsa' target='_blank' title='Genome Sequence Archive'>GSA</a></li>
                  <li><a href='https://ngdc.cncb.ac.cn/gwh' target='_blank' title='Genome Warehouse'>GWH</a></li>
                  <li><a href='https://bigd.big.ac.cn/gvm' target='_blank' title='Genome Variation Map'>GVM</a></li>
                  <li><a href='https://ngdc.cncb.ac.cn/gen' target='_blank' title='Gene Expression Nebulas'>GEN</a></li>
                  <li><a href='https://ngdc.cncb.ac.cn/ncov/' target='_blank'>RCoV19</a></li>
                </ul>
              </div>

              <div class='bigd-col-md-2'>
                <h3>Alliance & Collaboration</h3>
                <ul class='bigd-list-unstyled'>
                  <li><a href='http://bhbd-alliance.org' target='_blank'>BHBD</a></li>
                  <li><a href='https://bigd.big.ac.cn/p10k/' target='_blank'>P10K</a></li>
                  <li><a :href="bigd_site + 'partners'">Partners</a></li>
                  <li><a :href="bigd_site + 'collaborations'">Collaborations</a></li>
                  <li><a :href="bigd_site + 'funding'">Funding</a></li>
                  <li><a :href="bigd_site + 'contact'">Contact Us</a></li>
                  <li><a href='https://bigd.big.ac.cn/news/80'>Join Us</a></li>
                </ul>
              </div>

              <div class='bigd-col-md-2'>
                <h3>Conference & Outreach</h3>
                <ul class='bigd-list-unstyled'>
                  <li><a :href="bigd_site + 'conference'">Conferences</a></li>
                  <li><a :href="bigd_site + 'education'">Education</a></li>
                  <!-- <li><a :href="bigd_site + 'training'">Training</a></li>
                <li><a href="https://www.sciencedirect.com/journal/genomics-proteomics-and-bioinformatics"
                    target='_blank'>GPB</a></li> -->
                </ul>
              </div>

              <div class='bigd-col-md-2'>
                <ul class='bigd-list-unstyled'>
                  <h3>About</h3>
                  <li><a :href="bigd_site + 'about'">About NGDC</a></li>
                  <li><a :href="bigd_site + 'people'">People</a></li>
                  <li><a :href="bigd_site + 'mission'">Mission</a></li>
                  <li><a :href="bigd_site + 'board'">Advisory Board</a></li>
                  <li><a :href="bigd_site + 'structure'">Organizational Structure</a></li>
                  <li><a :href="bigd_site + 'history'">History</a></li>
                </ul>
              </div>
            </div>
            <hr class="footer-hr" />
            <div class='bigd-container'>
              <div class="bigd-row">
                <div class="bigd-col-md-3 bigd-center-block">
                  <img class="bigd-img-responsive" :src="bigd_site + 'static/image/cncb-logo.png'"
                    style="max-width: 80%;" />
                </div>
                <div class="bigd-col-md-8 bigd-col-lg-offset-1">
                  <p class="bigd-text-muted">
                    &copy; {{ year }} <a href="https://www.cncb.ac.cn" target="_blank">China National Center for
                      Bioinformation / Beijing Institute of Genomics, Chinese Academy of Sciences</a><br />
                    No.1 Beichen West Road, Chaoyang District, Beijing 100101, China<br />
                    Tel: +86 (10) 8409-7216 | Email: cncb(AT)big.ac.cn <br />
                  </p>
                  <p class="bigd-text-muted">
                    <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备10050270号</a><br />
                  </p>
                </div>
              </div>
              <div class="bigd-row">
                <div class="bigd-col-md-12">
                  <h5 class="bigd-text-center" style="font-size: 16px; font-weight: bold;">This database is free for
                    academic use only. For any commercial use,
                    please contact us for commercial licensing terms.</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </v-bottom-navigation>
</template>

<script>
export default {
  data() {
    return {
      bigd_site: "https://ngdc.cncb.ac.cn/",
      year: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>
</style>
